/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './layout/layout.component.ngfactory';
import * as i4 from './dashboard/dashboard.component.ngfactory';
import * as i5 from './errors/oneiam-error/oneiam-error.component.ngfactory';
import * as i6 from './errors/saml-error/saml-error.component.ngfactory';
import * as i7 from './errors/page-not-found/page-not-found.component.ngfactory';
import * as i8 from './app.component.ngfactory';
import * as i9 from '@angular/common';
import * as i10 from '@angular/platform-browser';
import * as i11 from '@angular/forms';
import * as i12 from 'obscache/dist/cache.service';
import * as i13 from '@angular/http';
import * as i14 from '../../app/common/services/user/user.service';
import * as i15 from '../../app/common/services/navigation/navigation.service';
import * as i16 from '@angular/router';
import * as i17 from '../../app/common/guards/auth/auth.guard';
import * as i18 from '../../app/layout/layout.component';
import * as i19 from '../../app/dashboard/dashboard.component';
import * as i20 from '../../app/errors/oneiam-error/oneiam-error.component';
import * as i21 from '../../app/errors/saml-error/saml-error.component';
import * as i22 from '../../app/errors/page-not-found/page-not-found.component';
import * as i23 from 'obscache/dist/cache.module';
import * as i24 from '../../app/common/services/services.module';
import * as i25 from '../../app/common/guards/guards.module';
import * as i26 from '../../app/common/pipes/pipes.module';
import * as i27 from '../../app/common/app-common.module';
import * as i28 from '../../app/dashboard/dashboard.module';
import * as i29 from '../../app/errors/oneiam-error/oneiam-error.module';
import * as i30 from '../../app/errors/page-not-found/page-not-found.module';
import * as i31 from '../../app/errors/saml-error/saml-error.module';
import * as i32 from '../../app/errors/errors.module';
import * as i33 from '../../app/layout/header/header.module';
import * as i34 from '../../app/layout/layout.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.LayoutComponentNgFactory,i4.DashboardComponentNgFactory,i5.OneiamErrorComponentNgFactory,
              i6.SamlErrorComponentNgFactory,i7.PageNotFoundComponentNgFactory,i8.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i9.NgLocalization,i9.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i10.DomSanitizer,i10.ɵe,[i9.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i10.DomSanitizer]),i0.ɵmpd(4608,
              i10.HAMMER_GESTURE_CONFIG,i10.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i10.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i10.ɵDomEventsPlugin(p0_0),new i10.ɵKeyEventsPlugin(p1_0),
                    new i10.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i9.DOCUMENT,i9.DOCUMENT,i9.DOCUMENT,i10.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i10.EventManager,i10.EventManager,[i10.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i10.ɵDomSharedStylesHost,i10.ɵDomSharedStylesHost,[i9.DOCUMENT]),
          i0.ɵmpd(4608,i10.ɵDomRendererFactory2,i10.ɵDomRendererFactory2,[i10.EventManager,
              i10.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,(null as any),
              [i10.ɵDomRendererFactory2]),i0.ɵmpd(6144,i10.ɵSharedStylesHost,(null as any),
              [i10.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,i0.Testability,
              [i0.NgZone]),i0.ɵmpd(4608,i10.Meta,i10.Meta,[i9.DOCUMENT]),i0.ɵmpd(4608,
              i10.Title,i10.Title,[i9.DOCUMENT]),i0.ɵmpd(4608,i11.ɵi,i11.ɵi,([] as any[])),
          i0.ɵmpd(4608,i12.CacheService,i12.CacheService,[i0.NgZone,i0.PLATFORM_ID]),
          i0.ɵmpd(4608,i13.BrowserXhr,i13.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i13.ResponseOptions,
              i13.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i13.XSRFStrategy,
              i13.ɵb,([] as any[])),i0.ɵmpd(4608,i13.XHRBackend,i13.XHRBackend,[i13.BrowserXhr,
              i13.ResponseOptions,i13.XSRFStrategy]),i0.ɵmpd(4608,i13.RequestOptions,
              i13.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i13.Http,i13.ɵc,[i13.XHRBackend,
              i13.RequestOptions]),i0.ɵmpd(4608,i14.UserService,i14.UserService,[i12.CacheService,
              i13.Http]),i0.ɵmpd(4608,i15.NavigationService,i15.NavigationService,
              [i16.Router]),i0.ɵmpd(4608,i17.AuthGuard,i17.AuthGuard,[i14.UserService,
              i15.NavigationService]),i0.ɵmpd(4608,i11.FormBuilder,i11.FormBuilder,
              ([] as any[])),i0.ɵmpd(5120,i16.ActivatedRoute,i16.ɵf,[i16.Router]),
          i0.ɵmpd(4608,i16.NoPreloading,i16.NoPreloading,([] as any[])),i0.ɵmpd(6144,
              i16.PreloadingStrategy,(null as any),[i16.NoPreloading]),i0.ɵmpd(135680,
              i16.RouterPreloader,i16.RouterPreloader,[i16.Router,i0.NgModuleFactoryLoader,
                  i0.Compiler,i0.Injector,i16.PreloadingStrategy]),i0.ɵmpd(4608,i16.PreloadAllModules,
              i16.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i16.ROUTER_INITIALIZER,
              i16.ɵi,[i16.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i16.ROUTER_INITIALIZER]),i0.ɵmpd(512,i9.CommonModule,i9.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i10.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i16.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i16.ɵg,i16.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i10.ɵc(p0_0,p0_1),i16.ɵh(p1_0)];
              },[[2,i10.NgProbeToken],[2,i0.NgProbeToken],i16.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i10.BrowserModule,i10.BrowserModule,[[3,i10.BrowserModule]]),
          i0.ɵmpd(512,i11.ɵba,i11.ɵba,([] as any[])),i0.ɵmpd(512,i11.FormsModule,i11.FormsModule,
              ([] as any[])),i0.ɵmpd(1024,i16.ɵa,i16.ɵd,[[3,i16.Router]]),i0.ɵmpd(512,
              i16.UrlSerializer,i16.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,
              i16.ChildrenOutletContexts,i16.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(256,i16.ROUTER_CONFIGURATION,{},([] as any[])),i0.ɵmpd(1024,i9.LocationStrategy,
              i16.ɵc,[i9.PlatformLocation,[2,i9.APP_BASE_HREF],i16.ROUTER_CONFIGURATION]),
          i0.ɵmpd(512,i9.Location,i9.Location,[i9.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,
              i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i16.ROUTES,
              () => {
                return [[{path:'',canActivate:[i17.AuthGuard],component:i18.LayoutComponent,
                    children:[{path:'',component:i19.DashboardComponent}]},{path:'',
                    component:i18.LayoutComponent,children:[{path:'oneiam/error',component:i20.OneiamErrorComponent},
                        {path:'saml/error',component:i21.SamlErrorComponent},{path:'**',
                            component:i22.PageNotFoundComponent}]}]];
              },([] as any[])),i0.ɵmpd(1024,i16.Router,i16.ɵe,[i0.ApplicationRef,i16.UrlSerializer,
              i16.ChildrenOutletContexts,i9.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i16.ROUTES,i16.ROUTER_CONFIGURATION,[2,i16.UrlHandlingStrategy],
              [2,i16.RouteReuseStrategy]]),i0.ɵmpd(512,i16.RouterModule,i16.RouterModule,
              [[2,i16.ɵa],[2,i16.Router]]),i0.ɵmpd(512,i23.CacheModule,i23.CacheModule,
              ([] as any[])),i0.ɵmpd(512,i24.ServicesModule,i24.ServicesModule,([] as any[])),
          i0.ɵmpd(512,i25.GuardsModule,i25.GuardsModule,([] as any[])),i0.ɵmpd(512,
              i13.HttpModule,i13.HttpModule,([] as any[])),i0.ɵmpd(512,i26.PipesModule,
              i26.PipesModule,([] as any[])),i0.ɵmpd(512,i11.ReactiveFormsModule,i11.ReactiveFormsModule,
              ([] as any[])),i0.ɵmpd(512,i27.AppCommonModule,i27.AppCommonModule,([] as any[])),
          i0.ɵmpd(512,i28.DashboardModule,i28.DashboardModule,([] as any[])),i0.ɵmpd(512,
              i29.OneiamErrorModule,i29.OneiamErrorModule,([] as any[])),i0.ɵmpd(512,
              i30.PageNotFoundModule,i30.PageNotFoundModule,([] as any[])),i0.ɵmpd(512,
              i31.SamlErrorModule,i31.SamlErrorModule,([] as any[])),i0.ɵmpd(512,i32.ErrorsModule,
              i32.ErrorsModule,([] as any[])),i0.ɵmpd(512,i33.HeaderModule,i33.HeaderModule,
              ([] as any[])),i0.ɵmpd(512,i34.LayoutModule,i34.LayoutModule,([] as any[])),
          i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9hcHAvc3JjL2FwcC9hcHAubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9hcHAubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts